module.exports = __webpack_public_path__ + "img/title.808d60c7.png";